import { Component, Host, h, Prop } from "@stencil/core";

/**
 * @slot - Slot for any content
 */
@Component({
  tag: "stzh-container",
  styleUrl: "stzh-container.scss",
  scoped: true,
})
export class StzhContainer {
  /** Size variant */
  // @Prop() size: "default" | "big" = "default";

  /** Whether to prevent side margins */
  @Prop() noMargin: boolean = false;

  render() {
    const classes = {
      "stzh-container": true,
      "stzh-container--has-no-margin": this.noMargin,
      // [`stzh-container--size-${this.size}`]: !!this.size,
    };

    return (
      <Host>
        <div class={classes}>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
